<template>
  <div>
    <div v-if="!forgotSuccess">
      <!-- Company Logo -->
      <company-logo />

      <!-- Header & Instruction -->
      <list-header title="Forgot your password?" />
      <div class="p-3 text-start">
        We'll send you an email with instructions to reset your password. Kindly
        report to the store if you are not able to receive the email.
      </div>

      <!-- Forgot Password Form -->
      <Form @submit="handleForgotPassword">
        <div class="my-4 scss-bold">
          <div class="d-flex flex-row">
            <div class="w-25 text-start ms-5">Email</div>
            <div class="w-50 text-start ms-5">
              {{ email }}
            </div>
          </div>
        </div>

        <div class="scss-button-position-bottom">
          <div>
            <default-button title="Reset Password" />
          </div>

          <div class="mb-2">
            <span
              class="scss-click-effect scss-text-blue scss-clickable"
              @click="goToSignInPage"
              >Back to login</span
            >
          </div>
        </div>
      </Form>
    </div>

    <div v-if="forgotSuccess">
      <!-- Booking Done Message -->
      <div class="style-container">
        <div class="px-3 mb-5">
          <div class="style-header scss-bold">Email Sent!</div>

          <div class="mt-5">
            <img src="@/assets/icons/green-tick.png" class="style-icon" />
          </div>

          <div class="mt-5 text-center scss-small-font">
            An email has been sent to you to reset password.
            <br />
            Check your inbox for details.
          </div>
        </div>
      </div>

      <!--Route to Sign In -->
      <div class="scss-button-position-bottom">
        <default-button title="Sign In Now" @click="goToSignInPage" />
      </div>
    </div>
  </div>
</template>

<script>
import { Form } from "vee-validate";
import { useToast } from "vue-toastification";
import {
  mapGetters,
  mapMutations
} from "vuex";

import ListHeader from "@/components/ListHeader.vue";
import DefaultButton from "@/components/button/DefaultButton.vue";
import { forgotPassword } from "@/services/auth";
import CompanyLogo from "@/components/CompanyLogo.vue";

export default {
  name: "SendResetRequest",
  components: {
    ListHeader,
    DefaultButton,
    Form,
    CompanyLogo,
  },
  data() {
    return {
      forgotSuccess: false,
    };
  },
  computed: {
    email() {
      const fullEmail = this.forgotPasswordTemporary?.email?.split("@");
      const frontEmail = fullEmail && fullEmail[0];
      const endEmail = fullEmail && fullEmail[1];
      return fullEmail && fullEmail[0] !== ""
        ? `${frontEmail?.slice(0, 1)}****@${endEmail?.charAt(
            0
          )}****${endEmail?.slice(endEmail?.length - 4)}`
        : null;
    },
    ...mapGetters(["forgotPasswordTemporary"]),
  },
  methods: {
    goToSignInPage() {
      this.$router.push("/login");
    },
    async handleForgotPassword() {
      this.showLoading(true);

      try {
        const response = await forgotPassword(this.forgotPasswordTemporary.phoneMobile);

        // Route to email sent successfully page
        if (response.status === 200) {
          this.forgotSuccess = true;
          this.showLoading(false);
        } else {
          throw new Error("Failed to sent reset password email");
        }
      } catch (error) {
        useToast().error("Oops. Something went wrong. Please try again.");
        this.showLoading(false);
      }
    },
    ...mapMutations(["showLoading"]),
  },
};
</script>
<style lang="scss" scoped>
.style-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}

.style-header {
  color: $text-green;
  font-size: 18px;
}

.style-icon {
  width: 40%;
  height: 40%;
}
</style>
